import { subscribeChannel, publishChannel } from './channelUtils';

export function sendTrips(trips) {

    publishChannel('trips-sync', trips);

}

export function sendTripUpsert(trip) {
    
    publishChannel('trip-upsert', trip);

}

export function sendTripRemove(tripUid) {
    
    publishChannel('trip-remove', tripUid);

}

export function sendSituacoes(situacoesSelecionadas) {
    
    publishChannel('situacoes-upsert', situacoesSelecionadas);

}

export function sendDesempenho(desempenhosSelecionados) {
    
    publishChannel('desempenhos-upsert', desempenhosSelecionados);

}

export function listenTrips(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'trips-sync' &&
            tipo !== 'trip-upsert' &&
            tipo !== 'trip-remove' &&
            tipo !== 'situacoes-upsert' &&
            tipo !== 'desempenhos-upsert'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}